import React from 'react';
import {
  arrayOf, number, oneOfType, shape, string,
} from 'prop-types';
import FileIcon from 'components/file-icon';
import { fileExtension, formatFileSize } from 'components/attachments/fileValidation';

const CommentAttachmentLinks = ({ attachments = [] }) => {
  if (attachments.length === 0) return null;

  return (
    <div className="ticket-comment__attachments">
      {attachments.map((file) => (
        <a
          key={file.uid ?? file.id}
          href={file.url}
          target="_blank"
          rel="noopener noreferrer"
          className="ticket-comment__attachment"
          title={file.name}
        >
          <FileIcon format={fileExtension(file)} />
          <span className="ticket-comment__attachment-name">{file.name}</span>
          <span className="ticket-comment__attachment-size">{formatFileSize(file.size)}</span>
        </a>
      ))}
    </div>
  );
};

CommentAttachmentLinks.propTypes = {
  attachments: arrayOf(shape({
    uid: oneOfType([number, string]),
    id: number,
    name: string,
    url: string,
    extension: string,
    size: number,
  })),
};

export default CommentAttachmentLinks;
